module.exports = __webpack_public_path__ + "static/media/link.c4794597.png";